import Horizontal from './HorizontalTabs';
import Vertical from './VerticalTabs';
/**
 * @deprecated
 */
export default { Horizontal, Vertical };
